import React, { useState } from 'react';
import s from './GenricReadMore.scss';

const GenricReadMore = props => {
  const { information, isAtf } = props;
  const [showMore, setShowMore] = useState(false);

  const handleClick = () => {
    setShowMore(!showMore);
  };
  return (
    <div className={`${isAtf ? s.atfText : ''}`}>
      <div
        className={`${s.genericReadMore} genericReadMore ${
          showMore ? s.expand : ''
        } `}
      >
        <div
          className={s.text}
          onClick={() => {
            handleClick();
          }}
        >
          {information}
        </div>
        <span
          onClick={() => {
            handleClick();
          }}
          className={`${s.readBtn} readBtn`}
        >
          {showMore ? 'Read Less' : 'Read More'}
        </span>
      </div>
    </div>
  );
};
export default GenricReadMore;
